import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("b", null, "Date Activated: ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "License: ", -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "License:", -1)
const _hoisted_5 = {
  key: 2,
  class: "license-controls"
}
const _hoisted_6 = {
  class: "form",
  ref: "form"
}
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "license" }, "License", -1)
const _hoisted_9 = { class: "field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "dateExpired" }, "Expiration Date", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.user.license)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("p", null, [
            _hoisted_1,
            _createElementVNode("span", null, _toDisplayString(_ctx.getDateString(_ctx.user.dateActivated)), 1)
          ]),
          _createElementVNode("p", null, [
            _hoisted_2,
            _createElementVNode("span", null, _toDisplayString(_ctx.user.license.title) + " (Expires: " + _toDisplayString(_ctx.user.dateExpired ? _ctx.getDateString(_ctx.user.dateExpired) : 'Never') + ") ", 1)
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" None (Expired " + _toDisplayString(_ctx.user.dateExpired ? _ctx.getDateString(_ctx.user.dateExpired) : 'N/A') + ") ", 1)
        ])),
    (_ctx.canEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_Button, {
            label: "Edit License",
            type: "button",
            onClick: _withModifiers(_ctx.openEditLicense, ["prevent"])
          }, null, 8, ["onClick"]),
          (_ctx.user.license)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                label: "Revoke License",
                type: "button",
                class: "p-button-danger",
                onClick: _withModifiers(_ctx.revokeLicense, ["prevent"])
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      header: "Edit License",
      visible: _ctx.editing,
      modal: true,
      closable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancel",
          class: "p-button-text",
          onClick: _withModifiers(_ctx.closeEditLicense, ["prevent"])
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "Update",
          onClick: _withModifiers(_ctx.updateLicense, ["prevent"])
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("form", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.updateLicenseModel.licenseId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.updateLicenseModel.licenseId) = $event)),
              options: _ctx.licenses,
              optionValue: "id",
              optionLabel: "title",
              placeholder: "Select a License",
              required: true
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_Calendar, {
              id: "dateExpired",
              modelValue: _ctx.updateLicenseModel.dateExpired,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.updateLicenseModel.dateExpired) = $event)),
              "min-date": _ctx.defaultDate,
              required: true
            }, null, 8, ["modelValue", "min-date"])
          ])
        ], 512)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}